module.exports = __webpack_public_path__ + "img/collection-memoireRingsPlatinum@2x.ccb6116.webp";